import MainNav from "./routes/MainNav";

function App() {
  return (
    <MainNav/>
  );
}

export default App;
